// config/session.js
export const SESSION_CONFIG = {
  // Session timeout in milliseconds (30 minutes)
  SESSION_TIMEOUT: 30 * 60 * 1000,
  
  // Warning timeout in milliseconds (5 minutes before session expires)
  WARNING_TIMEOUT: 5 * 60 * 1000,
  
  // Refresh interval in milliseconds (refresh token every 5 minutes)
  REFRESH_INTERVAL: 5 * 60 * 1000,
  
  // Activity events that reset the session timer (optimized for performance)
  ACTIVITY_EVENTS: [
    'mousedown',
    'keypress',
    'scroll',
    'touchstart',
    'click'
  ],
  
  // Debounce delay for activity events (prevents excessive timer resets)
  ACTIVITY_DEBOUNCE: 1000,
  
  // Systems that support session management
  SUPPORTED_SYSTEMS: ['eLearning', 'hmis', 'rafiki360', 'appeals'],
  
  // Session status display settings
  STATUS: {
    // Show status when less than 10 minutes remaining
    SHOW_THRESHOLD: 10 * 60 * 1000,
    
    // Warning threshold (5 minutes)
    WARNING_THRESHOLD: 5 * 60 * 1000,
    
    // Critical threshold (2 minutes)
    CRITICAL_THRESHOLD: 2 * 60 * 1000
  },
  
  // Performance optimizations
  PERFORMANCE: {
    // Update interval for UI (1 second)
    UI_UPDATE_INTERVAL: 1000,
    
    // Check session validity interval (30 seconds)
    VALIDITY_CHECK_INTERVAL: 30000,
    
    // Maximum concurrent timers per system
    MAX_TIMERS_PER_SYSTEM: 3
  },
  
  // Mobile-specific settings
  MOBILE: {
    // Touch events for mobile devices
    TOUCH_EVENTS: ['touchstart', 'touchend', 'touchmove'],
    
    // Reduced activity detection on mobile to save battery
    MOBILE_ACTIVITY_INTERVAL: 2000
  }
};

export default SESSION_CONFIG;
